// TopThreePositions
import React, {useEffect, useState} from "react";
import IconCrown from "../../assets/images/eoro-2024/icon-crown.svg";
import IconUserAvatar from "../../assets/images/eoro-2024/icon-user-avatar.svg";
import IconUpStanding from "../../assets/images/eoro-2024/icon-up-standing.svg";
import IconDownStanding from "../../assets/images/eoro-2024/icon-down-standing.svg";
import UserPredictedScoreModal from "./UserPredictedScoreModal";
import {useSelector} from "react-redux";
import {useSearchParams} from "react-router-dom";
import {GET_USER_PREDICTED_SCORE, OVER_ALL_LEADERBOARD, STAGING_BASE_URL} from "../../Axios/EndPoints";
import {get} from "../../Axios/get";

const TopThreePositions = (props) => {
    const {
        isMobile,
        topPositions,
        isGameWise,
        selectedMatchDay,
    } = props;
    const [params] = useSearchParams();
    const user = useSelector(state => state?.Login);

    // console.log("isGameWise on top three positions >>>", isGameWise)
    // console.log("selectedMatchDay on top three positions >>>", selectedMatchDay)

    const [userPredictedScoreModal, setUserPredictedScoreModal] = useState(false);
    // console.log("userPredictedScoreModal >>>", userPredictedScoreModal)
    const [userId, setUserId] = useState(null);
    // console.log("userId >>>>", userId)
    const [userPredictedData, setUserPredictedData] = useState(null);
    // console.log("userPredictedData >>>>>", userPredictedData)


    const getUserPredictedScore = (userId) => {
        let token = user?.user?.token;
        let isStaging = parseInt(params.get('staging'));
        let endpoint = `api/v1/euro/game/${selectedMatchDay}/user/${userId}/predictions`;
        // console.log(endpoint)
        get(
            endpoint,
            true,
            token,
            null,
            isStaging ? STAGING_BASE_URL : ''
        ).then(res => {
            // console.log("response for fetching user predicted score >>>", res?.data?.data);
            setUserPredictedData(res?.data?.data);
        }).catch(error => {
            console.error("Error while fetching user predicted score :", error);
        })

    }

    useEffect(() => {
        if (userId) {
            getUserPredictedScore(userId);
        }
    }, [userId]);

    // console.log("topPositions >>>", topPositions)
    const render = () => {
        return (
            <section className={"d-flex align-items-end justify-content-between w-100"}>
                <div className={"d-flex flex-column align-items-center gap-1"}>
                    <div className={"d-flex align-items-center gap-2"}>
                        {
                            topPositions[1]?.user?.arrow === "no_change" ?
                                <></>
                                :
                                <>
                                    <img
                                        src={topPositions[1]?.user?.arrow === "up" ? IconUpStanding : IconDownStanding}
                                        alt={"icon"}
                                        height={15}
                                        width={15}
                                    />
                                </>
                        }

                        <div
                            className={`fw-500 cabin font-20 ${isMobile ? "" : "text-white"}`}>{topPositions[1]?.position}</div>
                    </div>
                    <img
                        role={isGameWise && topPositions[1]?.user?.is_selection ? "button" : ""}
                        onClick={(e) => {
                            e.preventDefault();
                            isGameWise && topPositions[1]?.user?.is_selection && setUserPredictedScoreModal(true);
                            isGameWise && topPositions[1]?.user?.is_selection && setUserId(topPositions[1]?.user?.id);
                        }}
                        src={topPositions[1]?.user?.image || IconUserAvatar}
                        alt={"icon"}
                        className={"avatar-border-skins-grey"}
                        height={isMobile ? 65 : 80}
                        width={isMobile ? 65 : 80}
                    />
                    <div
                        className={`fw-800 bebas ${isMobile ? "font-22" : "text-white font-25"}`}>{topPositions[1]?.points}</div>
                    <div
                        className={"fw-500 cabin font-20 text-skins-medium-light-grey"}>{topPositions[1]?.user?.username}</div>
                </div>
                <div className={"d-flex flex-column align-items-center gap-1"}>
                    <div className={"d-flex align-items-center gap-3"}>
                        <img
                            src={IconCrown}
                            alt={"icon"}
                            height={70}
                            width={70}
                        />
                    </div>
                    <img
                        role={isGameWise && topPositions[0]?.user?.is_selection ? "button" : ""}
                        onClick={(e) => {
                            e.preventDefault();
                            isGameWise && topPositions[0]?.user?.is_selection && setUserPredictedScoreModal(true);
                            isGameWise && topPositions[0]?.user?.is_selection && setUserId(topPositions[0]?.user?.id);
                        }}
                        src={topPositions[0]?.user?.image || IconUserAvatar}
                        alt={"icon"}
                        className={"avatar-border-skins-golden"}
                        height={isMobile ? 100 : 140}
                        width={isMobile ? 100 : 140}
                    />
                    <div
                        className={`fw-800 bebas text-skins-gold ${isMobile ? "font-24" : "font-30"}`}>{topPositions[0]?.points}</div>
                    <div
                        className={"fw-500 cabin font-20 text-skins-medium-light-grey"}>{topPositions[0]?.user?.username}</div>
                </div>
                <div className={"d-flex flex-column align-items-center gap-1"}>
                    <div className={"d-flex align-items-center gap-2"}>
                        {
                            topPositions[2]?.user?.arrow === "no_change" ?
                                <></>
                                :
                                <>
                                    <img
                                        src={topPositions[2]?.user?.arrow === "up" ? IconUpStanding : IconDownStanding}
                                        alt={"icon"}
                                        height={15}
                                        width={15}
                                    />
                                </>
                        }

                        <div
                            className={`fw-500 cabin font-20 ${isMobile ? "" : "text-white"}`}>{topPositions[2]?.position}</div>
                    </div>
                    <img
                        role={isGameWise && topPositions[2]?.user?.is_selection ? "button" : ""}
                        onClick={(e) => {
                            e.preventDefault();
                            isGameWise && topPositions[2]?.user?.is_selection && setUserPredictedScoreModal(true);
                            isGameWise && topPositions[2]?.user?.is_selection && setUserId(topPositions[2]?.user?.id);
                        }}
                        src={topPositions[2]?.user?.image || IconUserAvatar}
                        alt={"icon"}
                        className={"avatar-border-skins-grey"}
                        height={isMobile ? 65 : 80}
                        width={isMobile ? 65 : 80}
                    />
                    <div
                        className={`fw-800 bebas ${isMobile ? "font-22" : "text-white font-25"}`}>{topPositions[2]?.points}</div>
                    <div
                        className={"fw-500 cabin font-20 text-skins-medium-light-grey"}>{topPositions[2]?.user?.username}</div>
                </div>
                {
                    isGameWise && userPredictedScoreModal && userId && userPredictedData &&
                    <>
                        <UserPredictedScoreModal
                            isMobile={isMobile}
                            showModal={userPredictedScoreModal}
                            setShowModal={setUserPredictedScoreModal}
                            userPredictedData={userPredictedData}
                        />
                    </>
                }
            </section>
        );
    }

    return render();
}

export default TopThreePositions;
